// enum
export var SEARCH_MODE;
(function (SEARCH_MODE) {
    SEARCH_MODE["PATENT"] = "PATENT";
    SEARCH_MODE["FAMILY"] = "FAMILY";
})(SEARCH_MODE || (SEARCH_MODE = {}));
export var UPDATE_TYPE;
(function (UPDATE_TYPE) {
    UPDATE_TYPE["ALL"] = "ALL";
    UPDATE_TYPE["NEW"] = "NEW";
})(UPDATE_TYPE || (UPDATE_TYPE = {}));
